import { useState, useCallback } from 'react';
import { Address } from '../services/api/types.ts';
import { getAllAddresses } from '../services/api/methods.ts';

export const useAddress = () => {
    const [address, setAddress] = useState<Address[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const loadAddress = useCallback(async () => {
        setLoading(true);
        setError('');

        try {
            const result = await getAllAddresses();
            setAddress(result.Addresses);
        } catch (err: any) {
            setError('Ошибка при загрузке адрессов');
            console.error('Ошибка при загрузке адрессов:', err);
            throw err;
        } finally {
            setLoading(false);
        }
    }, []);

    return {
        address,
        loading,
        error,
        loadAddress,
        setError
    };
};
